import { Block } from 'baseui/block';
import { Card } from 'baseui/card';
import { StyledDivider } from 'baseui/divider';
import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { userState } from '../../storage/userStates';
import UserCardHeader from './UserCardHeader';
import UserCardBody from './UserCardBody';


type Props = {
  id: string
};
function UserCard({ id }: Readonly<Props>) {
  const user = useRecoilValue(userState(id));

  if (!user) {
    return <></>; // TODO: skeleton
  }

  return (
    <Block>
      <Card
        overrides={{
          Root: {
            style: {
              height: 'calc(100% - 16px)',
              boxSizing: 'border-box',
              borderLeftWidth: '1px',
              borderRightWidth: '1px',
              borderTopWidth: '1px',
              borderBottomWidth: '1px',
            },
          },
          Contents: {
            style: {
              marginTop: 0,
              marginRight: 0,
              marginBottom: 0,
              marginLeft: 0,
            },
          },
          Body: {
            style: {
              marginBottom: 0,
            },
          },
        }}
      >
        <UserCardHeader user={user} />
        <StyledDivider
          $size="cell"
          style={{ marginTop: 0, marginBottom: 0 }}
        />
        <UserCardBody user={user} />
      </Card>
    </Block>
  );
}

export default memo(UserCard);
